var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.833h12.988l-4.47 4.47a.833.833 0 1 0 1.179 1.179l5.892-5.893a.844.844 0 0 0 .104-.127c.014-.02.023-.044.036-.065.013-.026.03-.05.04-.078.012-.028.019-.057.027-.087.007-.023.016-.045.02-.069A.834.834 0 0 0 17.334 7v-.002a.841.841 0 0 0-.016-.161c-.005-.025-.015-.048-.022-.073-.008-.028-.014-.056-.026-.083-.012-.029-.028-.055-.043-.082-.011-.02-.02-.041-.033-.061a.83.83 0 0 0-.104-.128L11.197.518a.834.834 0 0 0-1.179 1.179l4.47 4.47H1.5a.833.833 0 0 0 0 1.666Z",
    fill: "var(--color-primary-800)"
  })));
};
export default SvgArrowRight;